<script>
import WHThirdMenu from "@/layouts/website/components/WH/WHThirdMenu.vue";
import {Message} from "element-ui";
import {APP_MENU_ITEM_HEIGHT} from "@/config/app.config";

export default {
  name: "WHMoreMenu",
  components: {WHThirdMenu},
  data() {
    return {
      offset_left: 0,
      show: false,
    };
  },
  computed: {
    navs: function () {
      return this.$store.getters.website_nav;
    },
    nav_max_height: function () {
      let n_c_m_n = 0;

      function iteratorMenus(menus = []) {
        menus.map((nav) => {
          const n_c_l = (nav.children && nav.children.length) || 0;
          if (n_c_l) {
            if (n_c_l > n_c_m_n) n_c_m_n = n_c_l;
            iteratorMenus(nav.children);
          }
        });
      }

      iteratorMenus(this.navs);
      const m_m_h = APP_MENU_ITEM_HEIGHT * n_c_m_n;
      return (m_m_h + 1 + 1) + "px";
    },
  },
  mounted() {
    this.$bus.$on("SHOW-MORE-MENU", this.handleShowMoreMenu);
    this.$bus.$on("HIDE-MORE-MENU", this.handleHideMoreMenu);
  },
  methods: {
    handleOutSecondNav() {
      this.$refs.thirdMenuRef.hideMenu();
    },
    handleOnSecondNav(event, index, c_item) {
      if (c_item.children && c_item.children.length) {
        const secondEl = event.target.parentElement;
        const left = secondEl.offsetLeft;
        const width = secondEl.offsetWidth;
        this.$refs.thirdMenuRef.showMenu(left, width, c_item.children);
      } else {
        this.$refs.thirdMenuRef.hideMenu();
      }
    },

    getNavChildren(nav) {
      if (!nav.children || !nav.children.length) return [];
      return nav.children;
    },

    handleShowMoreMenu(offsetLeft) {

      if (offsetLeft && typeof offsetLeft === 'number') {
        this.offset_left = offsetLeft
      }

      this.show = true;
    },
    handleHideMoreMenu() {
      this.show = false;
    },
    handleMenuItem(menu) {
      console.log(menu);

      if (!menu.path) return Message.info("该菜单没有路径");
      this.$router.push(menu.path);
      this.handleHideMoreMenu();
    },
  },
};
</script>

<template>
  <div
      id="website-header-more-menu-id"
      class="website-header-more-menu"
      @mouseenter="handleShowMoreMenu"
      @mouseleave="handleHideMoreMenu"
      :class="{
      show: show,
    }"
      :style="{
      '--app-more-menu-main-nav-offset-left': offset_left +'px',
      '--app-more-menu-main-nav-max-height': nav_max_height,
    }"
  >
    <div class="w-h-m-menu-main">
      <div class="w-h-nav-item" v-for="(nav, index) in navs" :key="index">
        <div
            class="w-h-nav-c-item"
            v-for="(c_item, c_index) in getNavChildren(nav)"
            :key="c_index"
            @click.stop="handleMenuItem(c_item)"
            @mouseenter.stop.prevent="handleOnSecondNav($event, index, c_item)"
            @mouseleave.stop.prevent="handleOutSecondNav"
        >
          {{ c_item.title }}
        </div>
      </div>
    </div>
    <WHThirdMenu @hideWHMM="handleHideMoreMenu" ref="thirdMenuRef"/>
  </div>
</template>

<style lang="scss" scoped>
.website-header-more-menu {
  position: absolute;
  top: calc(100% - 1px);
  left: 0;
  padding-left: var(--app-more-menu-main-nav-offset-left);
  padding-right: calc(60px);
  width: 100%;
  height: 0;
  overflow: hidden;
  background-color: #f4f5f7;
  transition: height 0.1s ease-in-out;
  z-index: 2001;
  padding-top: 1px;

  &.show {
    height: var(--app-more-menu-main-nav-max-height);
  }

  .w-h-m-menu-main {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .w-h-nav-item {
      width: var(--app-header-menu-item-width);
      overflow-x: hidden;
      transition: width 0.2s;
      font-size: 16px;

      .w-h-nav-c-item {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 16px;
        height: var(--app-header-menu-item-height);
        line-height: var(--app-header-menu-item-height);
        cursor: pointer;
        text-align: center;
        user-select: none;

        &:hover {
          color: #D4062E;
          background-color: #F7EEEF;
        }
      }
    }
  }
}
</style>
